import React from 'react';
import { Box } from '@mui/material';

import { ButtonUI, DatagridPremiumUi, DialogUI, DataGridIdentifiers } from '../Interface';
import { dataGridPremiumColumns } from '../../utils/helper';

const ItemCompanyCatalogDialog = ({ open, onClose, rows, loading, onSelect }) => {
  const columns = dataGridPremiumColumns([
    {
      field: 'itemCodeInBp',
      headerName: 'ÜP cikkszám',
      type: 'string',
      flex: 1,
    },
    {
      field: 'itemNameInBp',
      headerName: 'ÜP cikknév',
      type: 'string',
      flex: 1,
    },
    {
      field: 'itemCode',
      headerName: 'Saját cikkszám',
      type: 'string',
      flex: 1,
    },
    {
      field: 'ownItemName',
      headerName: 'Saját cikknév',
      type: 'string',
      flex: 1,
    },
  ]);

  return (
    <DialogUI open={open} onClose={onClose} headerContent="ÜP cikkszámok" maxWidth="xl" fullWidth>
      <DatagridPremiumUi
        datagridIdentifier={DataGridIdentifiers.DocumentItemCompanyCatalogDialog}
        datagridInitialState={{ density: 'compact' }}
        rows={rows}
        columns={columns}
        loading={loading}
        hideFooter
        height={500}
        paginationAndfilterMode="client"
        disableSave
        headerFilters
        onRowClick={(params) => onSelect(params.row)}
        onRowDoubleClick={(params) => onSelect(params.row)}
        getRowId={(row) => row.id ?? `${row.companyId ?? ''}_${row.itemCode ?? ''}_${row.itemCodeInBp ?? ''}`}
      />

      <Box display="flex" justifyContent="center" gap="0.5rem" mt="1rem">
        <ButtonUI text="Bezárás" className="bg-primary" onClick={onClose} />
      </Box>
    </DialogUI>
  );
};

export default ItemCompanyCatalogDialog;
